module.exports = __webpack_public_path__ + "static/trace-ok-746a41a2b4bf404e3ca5ce799a9de32c.png";